module.exports = __webpack_public_path__ + "static/media/P1_S6_2.0df2ba73.jpg";